import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-column-options',
    templateUrl: './column-options.component.html',
    styleUrls: ['./column-options.component.scss'],
    standalone: false // NOSONAR
})
export class ColumnOptionsComponent implements OnInit {
  checkboxItems: any;
  checkboxItemsCopy: any;
  selectAllCheckBox: boolean = false;
  

  constructor(public dialogRef:MatDialogRef<ColumnOptionsComponent>,@Inject(MAT_DIALOG_DATA) public data:any) { }

  ngOnInit(): void {
    if(this.data.coldef) {
      this.checkboxItems = this.data.coldef;
      this.checkboxItems.forEach(element => {
           element['checkVar']=!element.hidden;     
      });
    this.checkboxItemsCopy = [];
      this.checkboxItems.forEach(val => this.checkboxItemsCopy.push(Object.assign({}, val)));
      this.checkSelectAll();
    }
  }

  checkSelectAll() {
    if(this.checkboxItems.length) {
      const unSelectedFound = this.checkboxItems.find(item => item.checkVar == false);  // NOSONAR
      if(unSelectedFound) {
        this.selectAllCheckBox = false;
      } else {
        this.selectAllCheckBox = true;
      }
    }
 }  
 
 

  getCheckedItems() {
    const checkedItems = this.checkboxItems;
    this.dialogRef.close({
      data: checkedItems
    })
  }
  onClmnOptCancel() {
    this.checkboxItems = [...this.checkboxItemsCopy];
    this.checkSelectAll();
    this.getCheckedItems();
  }

  preferences(item){
      item.hidden = !item.checkVar;
      this.checkSelectAll();
        
  }


  onSelectAllChange(value) {
    // selectAllCheckBox value = true...
    if(value) {
      this.checkboxItems?.forEach((col) => {
        col.hidden = false;
        col.checkVar=true;
      })
      
    } else {
      // selectAllCheckBox value = false...
      this.checkboxItems?.forEach((col) => {
        col.hidden = true;
        col.checkVar=false;
      })
    }
  }

}
 